import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CreatorCTA() {
  return (
    <section data-testid="creator-cta" className="mt-20 md:mt-24 px-6 md:px-12">
      <div className="max-w-[1400px] mx-auto relative overflow-hidden rounded-3xl border border-white/10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#2E1065] via-[#0B0B0F] to-[#7C2D12]" />
        <div className="absolute inset-0 opacity-40" style={{ backgroundImage: "radial-gradient(circle at 15% 20%, rgba(147,51,234,0.4), transparent 55%), radial-gradient(circle at 85% 80%, rgba(249,115,22,0.35), transparent 55%)" }} />
        <div className="relative p-10 md:p-16 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1">
            <h3 className="font-display text-4xl md:text-5xl font-black leading-[1.05] tracking-tight">
              Your Story <span className="ycn-gradient-text">Deserves a Channel.</span>
            </h3>
            <p className="mt-4 text-white/80 max-w-xl leading-relaxed">
              YCN is building a platform where creators, filmmakers, producers, podcasters, and storytellers can reach new audiences. Creator Submissions open soon — be the first to know.
            </p>
          </div>
          <div className="shrink-0">
            <Link to="/submit" data-testid="creator-cta-btn" className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-bold text-white bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 transition group">
              Learn More <ArrowRight size={18} className="group-hover:translate-x-0.5 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
